import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import Box from "@subly/s1/ui/atom/Box";
import Form from "@subly/s1/ui/atom/Form";
import Link from "@subly/s1/ui/atom/Link";
import Logo from "@subly/s1/ui/atom/Logo";
import Card from "@subly/s1/ui/base/Card";
import Button from "@subly/s1/ui/base/Button";
import Page from "@subly/s1/ui/base/Page";

import { useAuth } from "../fabric";


export default function Login() {
	const { form } = useAuth();
	const theme = useTheme();
	const style = {
		root: { gap: theme.spacing(3), justifyContent: "center" },
		logo: { margin: "0 auto" },
		form: { gap: theme.spacing(3) }
	};

	return (
		<Page maxWidth="dark" sx={style.root}>
			<Card>
				<Card.Content sx={{ gap: 3, p: 5 }}>
					<Logo color={theme.palette.tertiary.main} size={240} sx={style.logo} />
					<Typography variant="h1" fontSize={30} textAlign="center">
						Verify Your Identity
					</Typography>
					<Form sx={style.form}>
						<form.AppForm>
							<form.AppField name="email" children={(field) => <field.Input label="Email" placeholder="Use your company email" type="email" />} />
							<Box.Column gap={1}>
								<Button type="submit" variant="contained" color="secondary" onClick={form.handleSubmit}>Sign in</Button>
								<Typography component="span" variant="body2" color="text.primary" >
									By continuing, you agree to or <Link tab color="tertiary.main">Terms & Conditions</Link>.
								</Typography>
							</Box.Column>
						</form.AppForm>
					</Form>
				</Card.Content>
			</Card>
		</Page>
	);
}